import React from 'react';
import Girl from 'assets/images/girl.png';
import Girl1 from 'assets/images/girl-1.png';
import Girl2 from 'assets/images/girl-2.png';
import Stats from 'assets/images/stats.png';
import ImgN from 'assets/images/img-n.png';
import Traces from 'assets/images/traces.png';
import Question from 'assets/images/question.png';
import { useTranslation } from 'react-i18next';

const Shopping = ({ animationCount }) => {
  const { t } = useTranslation();
  return (
    <div className={`flex-fill d-md-flex polls-section with-hover ${animationCount ? `anim-${animationCount}` : ''}`}>
      <div className='position-relative'>
        <div className='img-paradox' />
        <h3 className='img-title'>{t('landing_polls_choose')}</h3>
        <img src={Question} alt='Question' className='img-question' />
        <img src={Traces} alt='Traces' className='img-traces' />
        <img src={Girl} alt='Girl' className='img-girl' />
        <img src={Girl1} alt='Girl' className='img-girl-1' />
        <img src={Girl2} alt='Girl' className='img-girl-2' />
        <img src={Stats} alt='Stats' className='img-stats' />
        <img src={ImgN} alt='N' className='img-n' />
      </div>
    </div>
  );
};

export default Shopping;
